import RegistrationLogin from 'apps/auth/components/registration/RegistrationLogin';
import { NO_AUTH_VIEW } from 'apps/auth/constants/ServerConstants';

const registration = [
    {
        path: ['/registration', '/login', '/restorepassword'],
        component: RegistrationLogin,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        isBufferZone: true,
        isPathWithoutFooter: false,
        stateOptions: {
            registrationFlow: true,
            openChatInNoAuthZone: true,
            introPage: true,
            showChat: true,
        },
        useSingleRoute: true,
    },
];
export default registration;
